import { render, staticRenderFns } from "./PermPlacementDetailsForm.vue?vue&type=template&id=80953052&scoped=true&"
import script from "./PermPlacementDetailsForm.vue?vue&type=script&lang=js&"
export * from "./PermPlacementDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./PermPlacementDetailsForm.vue?vue&type=style&index=0&id=80953052&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80953052",
  null
  
)

export default component.exports